import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';
import { BackgroundCheck } from './background-check';
import { SignatureRequest } from './signature-request';

@inheritSerialization(AbstractModel)
export class TncDriverProfile extends AbstractModel {
  @autoserialize
  active: boolean;

  @autoserialize
  driverId: number;

  @autoserialize
  documentsApproved: boolean;

  @autoserialize
  hasAllDocuments: boolean;

  @autoserialize
  attendedAdaTraining: boolean;

  @autoserialize
  cprTestPassed: boolean;

  @autoserialize
  sterlingCandidateId: number;

  @autoserialize
  backgroundChecks: Array<BackgroundCheck>;

  @autoserialize
  signatureRequests: Array<SignatureRequest>;
}
